<template>
  <div class="my-weiper-container" :class="{'my-weiper-container-mob': !isPC}">
    <div class="hide">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txsh1mob.jpg" alt="">

    </div>
    <!-- <div class="title" :class="{'title-mob': !isPC}">
      <div class="title-pre">赛图斯</div>
      <div class="title-main">TVC</div>
    </div> -->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :class="{'swiper-slide-mob': !isPC}" v-for="(item,index) in imgs" :key="index">
          <div class="imgBox">
            <img :src="item.img" alt="" :data-index="index" :code-stm="`event, PAGEURL页面, 查看详情${item.img}`">
            <!-- <div v-if="showCoverBox" class="coverBox"></div> -->
          </div>
          <div class="info">{{item.title }}</div>
          <img :code-stm="`event, PAGEURL页面, 查看详情${item.img}`" v-if="item.video" :data-index="index" class="icon-play" :class="{'icon-play-mob': !isPC}" src="../assets/images/play.png" alt="">
        </div>
      </div>
      <div
        v-if="false && imgList && imgList.length>1"
        class="swiper-button-next"
        :class="{'swiper-button-mob': !isPC}"
        id="swiper-button-next"
        :code-stm="`event, PAGEURL页面, 轮播下一页`"
      >
      </div>
      <div
        v-if="false && imgList && imgList.length>1"
        class="swiper-button-prev"
        :class="{'swiper-button-mob': !isPC}"
        id="swiper-button-prev"
        :code-stm="`event, PAGEURL页面, 轮播上一页`"
      >
      </div>
      <div class="swiper-pagination" :class="{'swiper-pagination-mob': !isPC}"></div>
    </div>

    <div class="cover" v-if="isShowCover">
      <i class="el-icon-close" v-if="!isShowVideo" :class="{'el-icon-close-mob': !isPC}" @click="hideCover" :code-stm="`event, PAGEURL页面, 关闭弹窗`"></i>
      <i class="el-icon-close" v-else :class="{'el-icon-close-mob': !isPC}" @click="hideVideo" :code-stm="`event, PAGEURL页面, 关闭视频`"></i>
      <div class="pop" v-show="!isShowVideo">
        <div class="swiper-container2" :class="{'swiper-container2-mob': !isPC}">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in imgs" :key="index+'cover'">
              <img :src="item.imgNomalBig" :data-pop-Index="index" alt="" :code-stm="`event, PAGEURL页面, 弹窗视频播放${item.video}`">
              <img class="icon-play  icon-play-2" :data-pop-index="index" :code-stm="`event, PAGEURL页面, 弹窗视频播放${item.video}`" v-if="item.video" src="../assets/images/play.png" alt="">
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination2"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next swiper-button-next2" :code-stm="`event, PAGEURL页面, 弹窗轮播下一页`"></div>
        <div class="swiper-button-prev swiper-button-prev2" :code-stm="`event, PAGEURL页面, 弹窗轮播上一页`"></div>
      </div>
      <div class="pop-video" :class="{'pop-video-mob': !isPC}" v-if="isShowVideo">
        <video class="my-video" :src="videoSrc" autoplay="true" loop="false" muted="false" direction="0" controls></video>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      imgList: [],
      imgListPc: [
        'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshpc.jpg',
        'https://www.kia.cn//assets/~/media/images/vehicle/sp2c/videos-swiper/2026xcxtpc.jpg',
      ],
      imgListMob: [

        'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshmob.jpg',
        'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshmob.jpg',
      ],
      isShowCover: false,
      swiperCover: null,
      imgs: [
        {
          img: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026xcxtpc.jpg',
          imgNomal: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026xcxtpc.jpg',
          imgActive: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026xcxtactive.jpg',
          imgNomalBig: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026xcxtmob.jpg',
          title: '2026款 赛图斯 x 小城夏天',
          video: "https://img.kia.cn/media/videos/saitusi/2026-seltos-xiaochengxiatian.mp4",
        },
        {
          img: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshpc.jpg',
          imgNomal: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshpc.jpg',
          imgActive: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshactive.jpg',
          imgNomalBig: 'https://www.kia.cn/assets/~/media/images/vehicle/sp2c/videos-swiper/2026txshmob.jpg',
          title: '2026款 赛图斯 x 贴心守护',
          video: "https://img.kia.cn/media/videos/saitusi/2026-seltos-tiexinshouhu.mp4",
        },

      ],
      showCoverBox: false,
      isShowVideo: false,
      videoSrc: "",
    };
  },
  mounted: function () {
    let that = this;
    let preIndex = 2;
    this.imgList = !this.isPC ? this.imgListMob : this.imgListPc
    this.$nextTick(()=> {
      if (this.isPC) {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 2,
          spaceBetween: 40,
          centeredSlides: true,
          loop: true,
          observer: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          on:{
            slideChange: function(){
              // console.log('改变了，activeIndex为'+this.activeIndex);
              const len = that.imgs.length
              that.imgs.forEach((item, index) => {
                item.img = item.imgNomal
              });
              if (this.activeIndex >= 2) {
                // that.imgs[(this.activeIndex-2) % len].img = that.imgs[(this.activeIndex-2) % len].imgActive
                // console.log(that.imgs[(this.activeIndex-3)%5].img);
                // console.log(that.imgs[(this.activeIndex-3)%5].imgNomal);
              }
              if (this.activeIndex == 7 && this.activeIndex > preIndex) {
                swiper.slideTo(2, 0)
              } else if (this.activeIndex == 2 && this.activeIndex < preIndex) {
                swiper.slideTo(this.activeIndex + len, 0)
              }
              // console.log(preIndex);
              preIndex = this.activeIndex
            },
          },
          mousewheel: false
        });
        window.addEventListener("click", this.showCover)
      } else {
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '#swiper-button-next',
            prevEl: '#swiper-button-prev',
          },
        });
        window.addEventListener("click", this.showCover)
      }
      this.swiperCover = new Swiper('.swiper-container2', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '.swiper-pagination2',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    })
  },
  methods: {
    showCover(e) {
      const index = e.target.getAttribute('data-index')
      // console.log(index);
      if (index) {
        this.isShowCover = true
        this.$nextTick(()=> {
          this.swiperCover = new Swiper('.swiper-container2', {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination2',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next2',
              prevEl: '.swiper-button-prev2',
            },
          });
        })
        window.removeEventListener("click",this.showCover)

        window.addEventListener("click",this.showVideo)
      }
    },
    hideCover() {
      this.isShowCover = false
      this.swiperCover = null
      window.addEventListener("click", this.showCover)
      window.removeEventListener("click", this.showVideo)
      this.hideVideo()
    },

    showVideo(e) {
      const index = e.target.getAttribute('data-pop-index')
      // console.log(index);
      if(this.imgs[index] && this.imgs[index].video) {
        this.videoSrc = this.imgs[index].video
        this.isShowVideo = true
      }
    },
    hideVideo() {
      this.videoSrc = ""
      this.isShowVideo = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";
.my-weiper-container {
  position: relative;
  height: 100%;
  width: 100%;
  user-select: none;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .hide {
    position: absolute;
    top: -999px;
    left: -999px;
    opacity: 0;
  }
  .title {
    text-align: center;
    margin-bottom: 30px;
    &-mob {
      margin-bottom: 0;
    }
    &-pre {
      font-size: 18px;
    }
    &-main {
      font-size: 38px;
    }
  }
  img{
    width: 100%;
    height: auto;
  }
  .swiper-container {
	  position: relative;
    width: 80%;
    height: auto;
    padding-bottom: 45px;
    /* overflow: visible; */
  }
  @media (max-width: 768px) {
    .swiper-container {
      width: 100%;
      min-height: unset;
    }
  }
  .swiper-slide {
    /* text-align: center; */
    font-size: 18px;
    /* background: #eee; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: 300ms;
    cursor: pointer;
    .info {
      width: 100%;
      text-align: center;
      margin-top: 24px;
      white-space: pre-line;
    }
    .icon-play {
      width: 10%!important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -100%);
      &-2 {
        transform: translate(-50%, -50%);
      }
      &-mob {
        top: calc(50% - 10px);
      }
    }
    .imgBox {
      width: 100%;
      position: relative;
      .coverBox {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
      }
      &:hover {
        .coverBox {
          opacity: 0;
        }
      }
    }

    &-mob {
      transform: scale(1);
    }
  }
  .swiper-slide-active,.swiper-slide-duplicate-active{
   transform: scale(1);
  }
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    /* bottom: -45px; */
  }
  .swiper-container-horizontal > .swiper-pagination-progressbar, .swiper-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    top: unset;
    height: 2px;
    bottom: 0;
  }
  ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #05141f!important;
  }
  ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
    .swiper-pagination-bullet {
      width: 32px;
      height: 2px;
      background: #05141F;
      border-radius: 0;
    }
    .swiper-pagination-bullet-active {
      width: 48px;
    }
  }
  .swiper-button-next, .swiper-button-prev {
    width: 2.91666vw;
    height: 2.91666vw;
    background: rgba($color: #fff, $alpha: 0.8);
    transition: all .5s;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    transform: translateY(-50%);
    &::after {
      /* content: none; */
      font-size: 16px;
      font-weight: 900;
      color: rgba(5, 20, 31, 0.8);
    }
    &:hover {
      background: rgba($color: #05141F, $alpha: 0.8);
    }
    &:hover::after {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .swiper-button-prev, .swiper-button-next:focus {
    outline: none;
  }
  .swiper-button-next {
      right: 2%;
  }
  .swiper-button-prev {
      left: 2%;
  }
  &-mob {
    padding: 0;
    .title {
      padding: 10px 5%;
      font-size: 28px;
    }
    .swiper-container {
      /* padding: 0; */
    }
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      /* bottom: -20px; */
    }
    ::v-deep .swiper-container-horizontal > .swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 8px;
        height: 2px;
        background: #05141F;
        border-radius: 0;
      }
      .swiper-pagination-bullet-active {
        width: 16px;
      }
    }
    .swiper-button-mob {
      width: 30px;
      height: 30px;
      background: rgba($color: #000000, $alpha: 0);
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      top: calc(50% - 30px);
      transform: translateY(0);
      &::after {
        font-size: 16px;
        font-weight: 900;
        color: #fff;
      }
      &:hover {
        background: rgba($color: #000000, $alpha: 0);
      }
      &:hover::after {
        color: #fff;
      }
    }
  }
  /* @media screen and (orientation: portrait) {
    padding: 20px 0 25px;
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -20px;
    }
  } */

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 10;
    .el-icon-close {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: 50px;
      top: 50px;
      &-mob {
        font-size: 30px;
        right: 20px;
      }
    }
    .pop {
      position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .pop-video {
      width: 60%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &-mob {
        width: 100%;
      }
      video {
        width: 100%;
      }
    }
    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;
      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
      /* height: 80%; */
      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);
        img {
          width: 78%;
          height: auto;
        }
        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }
        .icon-play {
          width: 5%!important;
        }
        @media (max-width: 768px) {
          .icon-play {
            width: 10%!important;
          }
        }
      }
      &-mob {
        width: 100vw;
      }
    }
    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -30px;
      color: #fff;
    }
    .swiper-button-next, .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);
      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }
      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }
      &:hover::after {
        color: #fff;
      }
    }
    .swiper-button-prev, .swiper-button-next:focus {
      outline: none;
    }
    .swiper-button-next2 {
        right: 0;
        transform: translateY(-25%);
    }
    .swiper-button-prev2 {
        left: 0;
        transform: translateY(-25%);
    }
    @media (max-width: 768px) {
      .swiper-button-next2 {
          width: auto;
          height: auto;
          right: 2%;
          transform: translateY(25%);
      }
      .swiper-button-prev2 {
          width: auto;
          height: auto;
          left: 2%;
          transform: translateY(25%);
      }
    }
  }
}
</style>
